@if (hasContext()) {
  <!--
    if there is a context, we don't need a section as the content is still
    wrapped in a dynamic row. This check is absolute when the content migration
    for accessibility is done. This should be finished end of 2025
  -->
  <ng-container *ngTemplateOutlet="contentWrapper" />
} @else {
  <section
    [ngClass]="'content-section content-section--' + theme()"
    [class.content-section--fluid]="fluid()"
    [attr.id]="id()"
  >
    <div [class.container]="!fluid()">
      <ng-container *ngTemplateOutlet="contentWrapper" />
    </div>
  </section>
}
<ng-template #contentWrapper>
  <ng-content />
</ng-template>
